import configApi from '@/api/system/config'
import qs from 'qs'
const system = {
	state: {
		initConfig: false,
		version:'',
		login:'',
		title : '',
		company:'',
		copyright:'',
		logo:''
	},
	getters: {
	},
	mutations: {
		SET_INITCONFIG( state, initConfig ) {
			state.initConfig = initConfig
		},
		SET_VERSION( state, version) {
			state.version = version
		},
		SET_LOGIN( state, login) {
			state.login = login
		},
		SET_TITLE( state, title) {
			state.title = title
		},
		SET_COMPANY( state, company) {
			state.company = company
		},
		SET_COPYRIGHT( state, copyright) {
			state.copyright = copyright
		},
		SET_LOGO( state, logo) {
			state.logo = logo
		}
	},
	actions: {
		initSysConfig({ state,commit }, path) {
			return new Promise(( resolve, reject )=>{
				if(!state.initConfig){
					const query = qs.parse(location.search.substring(1))
					let v = query.v
					configApi.getVersions({v:v}).then(res=>{
						// console.log('getVersions', res)
						commit('SET_INITCONFIG',true)
						commit('SET_VERSION','1.0')
						commit('SET_LOGIN',true)
						commit('SET_TITLE',res.data.data.title)
						commit('SET_COMPANY',res.data.data.company_name)
						commit('SET_COPYRIGHT',res.data.data.copyright)
						commit('SET_LOGO',res.data.data.logo)
						resolve()
					})
				}else{
					resolve()
				}
			})
			
		}
	}
}
export default system
